import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { CloseButton, CloseButtonSpacer } from '../tools/components';
import { getContentWidth, getContentMaxWidth } from './utils';
import { upToSm } from '../tools/utils';
const fullScreenStyles = css `
  width: 100vw;
  height: 100%;
  margin: 0;
  overflow-y: scroll;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
`;
const DialogContent = styled.div `
  ${({ theme: { media, colors }, $fullScreenSmDown, $fullScreenMdOnly, $height, $width = 'lg', }) => `
      position: relative;
      background: ${colors.white};
      height: ${$height || 'fit-content'};
      box-sizing: border-box;
      max-width: 100vw;
      outline: none;
      overflow: hidden;
      border-radius: 4px;
      box-shadow: 0 2px 4px -2px rgba(0,0,0,0.16), 0 5px 8px -4px rgba(0,0,0,0.16); 

      ${media.down('sm')} {
        width: ${getContentWidth({
    modalWidth: $width,
    screenWidth: 'sm-down',
})};
        ${$fullScreenSmDown ? `${fullScreenStyles}` : ''}
      }

      ${media.between('md', 'md')} {
        width: ${getContentWidth({
    modalWidth: $width,
    screenWidth: 'md-only',
})};
        ${$fullScreenMdOnly ? `${fullScreenStyles}` : ''}
      }

      ${media.up('lg')} {
        width: ${getContentWidth({ modalWidth: $width, screenWidth: 'lg-up' })};
        max-width: ${getContentMaxWidth($width)};
      }
  `}
`;
const StyledBox = styled(Box) `
  ${({ theme: { media }, $fullScreenSmDown, $fullScreenMdOnly }) => `
    ${media.down('sm')} {
      ${$fullScreenSmDown ? `flex: 1;` : ''}
    }

    ${media.between('md', 'md')} {
      ${$fullScreenMdOnly ? `flex: 1;` : ''}
    }
  `}
`;
export const DialogContentBase = ({ content, disableFullScreenSmDown, fullScreenMd, height, width, hideCloseButton, dataTrackRegion, className, ariaLabelCloseButton, allytmlnCloseButton, onClose, dialogContentRef, }) => {
    return (React.createElement(DialogContent, { "$fullScreenSmDown": !disableFullScreenSmDown, "$fullScreenMdOnly": !!fullScreenMd, "$height": height, "$width": width, onClick: (e) => e.stopPropagation(), className: className, ref: dialogContentRef, role: "dialog", "aria-modal": "true", "data-testid": "mui-modal-container", "data-track-region": dataTrackRegion },
        !hideCloseButton && (React.createElement(CloseButtonSpacer, { isFullScreenSmDown: !disableFullScreenSmDown })),
        React.createElement(StyledBox, { p: upToSm('md', 'lg'), "$fullScreenSmDown": !disableFullScreenSmDown, "$fullScreenMdOnly": !!fullScreenMd }, content),
        !hideCloseButton && (React.createElement(CloseButton, { "data-testid": "close-modal", "data-track-elem": "icon", "data-track-name": "Close", "data-track-trigger": "close", ariaLabel: ariaLabelCloseButton, allytmln: allytmlnCloseButton, onClick: onClose }))));
};
//# sourceMappingURL=DialogContentBase.js.map